<mat-spinner *ngIf="isLoading" [diameter]="26"></mat-spinner>

<button mat-icon-button [matMenuTriggerFor]="notifMenu" *ngIf="!isLoading">
    <mat-icon aria-label="Notifications" matBadgeColor="warn" *ngIf="notifications.length"
        [matBadge]="notifications.length" [matBadgeHidden]="!notifications.length">
        notifications
    </mat-icon>
    <mat-icon aria-label="No notification" *ngIf="!notifications.length">
        notifications_none
    </mat-icon>
</button>

<mat-menu #notifMenu="matMenu" class="notif-menu">
    <h4>Notifications</h4>
    <mat-list class="notif-list" *ngIf="notifications.length" (click)="$event.stopPropagation()">
        <!-- <mat-list class="notif-list" *ngIf="notifications.length"> -->
        <mat-list-item *ngFor="let notification of notifications">
            <!-- <mat-icon mat-list-icon color="accent">{{ notification.icon }}</mat-icon> -->
            <h5 mat-line>
                Your video is ready to <a [routerLink]="['/smartwaste/Timeline']"> play</a>
            </h5>
        </mat-list-item>
    </mat-list>
    <section class="actions">
        <button mat-raised-button color="primary" [disabled]="!notifications.length" (click)="onClear()">
            Delete
        </button>
    </section>

</mat-menu>